export default __webpack_public_path__ + "static/media/sc_print.d6988774.png";